import React, { useEffect } from "react";
import PublicHeader from "../WebsiteComponents/PublicHeader";
import PublicFooter from "../WebsiteComponents/PublicFooter";
import { useLocation } from "react-router-dom";

const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return (
    <div className="public-layout">
      {/* Skip link: accessibility + lets crawlers/readers identify the primary content */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[10000] focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-[#48247f] focus:shadow-lg"
      >
        Skip to main content
      </a>
      <PublicHeader />
      {/* The ONE <main> landmark for every public page */}
      <main id="main-content" className="public-main">
        {children}
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
